import React from 'react';

const LABELS = ['Service', 'Staff', 'Date', 'Time', 'Confirm', 'Payment'];

export default function ProgressBar({ step }) {
  return (
    <div className="w-progress" style={{ display: 'flex', alignItems: 'center', gap: 0, marginBottom: 4 }}>
      {LABELS.map((label, i) => (
        <React.Fragment key={label}>
          <div
            className={`w-step-dot ${i === step ? 'active' : i < step ? 'done' : ''}`}
            title={label}
          />
          {i < LABELS.length - 1 && (
            <div className={`w-step-line ${i < step ? 'done' : ''}`} />
          )}
        </React.Fragment>
      ))}
      <span className="w-step-label">{LABELS[step]}</span>
    </div>
  );
}
